import { ApolloClient, MutationOptions } from "apollo-boost";
import { ApiFields } from "./api-fields";
import { ApiMutation } from "./api-mutation";
import { FieldNameComposer } from "../shared/fieldname-composer";
import { MutationTypeEnum } from "@graphapi-io/declarations";
import { GqlMutationComposer } from "./gql-mutation-composer";

export class ApiCreateMutations {
  private customerApiMutation: ApiMutation;

  constructor(
    private apolloClient: ApolloClient<unknown>,
    private customerApiFields: ApiFields,
  ) {
    this.customerApiMutation = new ApiMutation(
      MutationTypeEnum.CREATE,
      this.apolloClient,
    );
  }

  public async createObject(
    typeName: string,
    variables: { input: Record<string, unknown> },
    updateCache?: MutationOptions<any>["update"],
  ) {
    return this.customerApiMutation.mutate(
      GqlMutationComposer.buildCreateMutation(typeName, this.customerApiFields),
      variables,
      FieldNameComposer.fieldNameForMutationType(
        MutationTypeEnum.CREATE,
        typeName,
      ),
      updateCache,
    );
  }

  public async batchCreateObjects(
    typeName: string,
    variables: { input: Record<string, unknown>[] },
    updateCache?: MutationOptions<any>["update"],
  ) {
    return this.customerApiMutation.batchMutate(
      GqlMutationComposer.buildBatchCreateMutation(
        typeName,
        this.customerApiFields,
      ),
      variables,
      FieldNameComposer.fieldNameForMutationType(
        MutationTypeEnum.BATCH_CREATE,
        typeName,
      ),
      updateCache,
    );
  }
}
